
import { mapActions, mapGetters } from 'vuex';
import tracking from '@/functions/tracking';

interface Data {
    modalName: string;
    isPlayingVideo: boolean;
    showPlayPauseButton: boolean;
    propertyId: string;
    togglePlayUsed: boolean;
}

export default {
    name: 't-property',
    data(): Data {
        return {
            modalName: 'comingSoonInfoCurtain',
            isPlayingVideo: true,
            showPlayPauseButton: false,
            propertyId: '',
            togglePlayUsed: false,
        };
    },

    mounted(): void {
        const vid = this.$root.$refs.propertyHeroVideo as HTMLVideoElement;

        if (vid) {
            this.propertyId = vid.dataset.propertyid;
            vid.addEventListener(
                'play',
                () => {
                    tracking.track(
                        'trackBoligpraesentation',
                        'Boligpraesentation',
                        'Video synlig',
                        this.propertyId,
                        {
                            type: 'Mosaik',
                        },
                    );
                    this.showPlayPauseButton = true;
                },
                {
                    once: true,
                },
            );

            // Ended event is not fired on looped videos
            // Therefore we need to listen for the ended
            // event and set the loop property of the video manually
            // vid.addEventListener(
            //     'ended',
            //     () => {
            //         tracking.track(
            //             'trackBoligpraesentation',
            //             'Boligpraesentation',
            //             'Video slut',
            //             this.propertyId,
            //             {
            //                 type: 'Mosaik',
            //             },
            //         );
            //         vid.setAttribute('loop', '');
            //         vid.play();
            //     },
            //     {
            //         once: true,
            //     },
            // );
        }
    },

    computed: {
        ...mapGetters({
            show: 'modal/show',
            type: 'modal/type',
        }),

        showComingSoonInfoCurtain(): boolean {
            return this.show && this.type === this.modalName;
        },
    },

    methods: {
        ...mapActions({
            openModal: 'modal/open',
        }),

        togglePlay(): void {
            const vid = this.$root.$refs.propertyHeroVideo as HTMLVideoElement;
            if (!vid) return;

            if (vid.paused) {
                vid.play();
                this.isPlayingVideo = true;
            } else {
                vid.pause();
                this.isPlayingVideo = false;
            }

            if (!this.togglePlayUsed) {
                this.togglePlayUsed = true;

                tracking.track(
                    'trackBoligpraesentation',
                    'Boligpraesentation',
                    'Video pause',
                    this.propertyId,
                    {
                        type: 'Mosaik',
                    },
                );
            }
        },

        /**
         * Open property gallery with galleryItemId and galleryMediaType.
         *
         * @return {void}
         */
        openGallery(galleryItemId: string, mediaType: string): void {
            (this.$root.$refs.propertyGallery as any).show(
                galleryItemId,
                mediaType,
            );
        },

        /**
         * Open property interactive gallery with index.
         *
         * @return {void}
         */
        openInteractiveGallery(value: string): void {
            (this.$root.$refs.propertyInteractiveGallery as any).show(value);
        },

        openComingSoonInfoCurtain(): void {
            this.openModal(this.modalName);
        },
    },
};
